var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavClose = function SvgNavClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081B36",
    d: "m.335 8.727.94.94L5 5.94l3.727 3.727.94-.94L5.941 5l3.727-3.727-.94-.94L5.001 4.06 1.275.333l-.94.94L4.06 5z"
  })));
};
export default SvgNavClose;